
import Button from '../../../components/base/Button';

export default function CaseStudyHighlights() {
  const caseStudies = [
    {
      client: 'Luxury Jewelry Brand',
      industry: 'E-commerce',
      challenge: 'Low online sales and poor ROAS',
      result: '300% increase in revenue',
      metric: '+300% Revenue',
      description: 'Transformed their Meta Ads strategy and website design, resulting in a 300% revenue increase within 6 months.',
      image: 'https://public.readdy.ai/ai/img_res/544d025dc81758e842f7509fdc3545e7.jpg'
    },
    {
      client: 'Fitness Training Institute',
      industry: 'Education',
      challenge: 'Low enrollment and brand awareness',
      result: '250% increase in enrollments',
      metric: '+250% Enrollments',
      description: 'Developed comprehensive digital marketing strategy including SEO, Google Ads, and social media campaigns.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20fitness%20gym%20with%20professional%20trainers%20and%20students%2C%20bright%20and%20motivational%20atmosphere%2C%20exercise%20equipment%20and%20training%20sessions%2C%20clean%20and%20energetic%20environment&width=400&height=300&seq=fitness-case&orientation=landscape'
    },
    {
      client: 'Boutique Hotel Chain',
      industry: 'Hospitality',
      challenge: 'Seasonal booking fluctuations',
      result: '180% increase in direct bookings',
      metric: '+180% Bookings',
      description: 'Implemented targeted advertising campaigns and optimized their booking website for better conversions.',
      image: 'https://readdy.ai/api/search-image?query=Luxurious%20boutique%20hotel%20lobby%20with%20elegant%20interior%20design%2C%20comfortable%20seating%20areas%2C%20warm%20lighting%2C%20modern%20hospitality%20aesthetic%2C%20welcoming%20atmosphere&width=400&height=300&seq=hotel-case&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Success Stories
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            See how we've helped businesses across different industries achieve remarkable growth through our strategic marketing approach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {caseStudies.map((study, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src={study.image}
                alt={study.client}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                    {study.industry}
                  </span>
                  <span className="text-lg font-bold text-green-600">
                    {study.metric}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {study.client}
                </h3>
                <p className="text-gray-600 mb-4">
                  {study.description}
                </p>
                <div className="text-sm text-gray-500">
                  <strong>Challenge:</strong> {study.challenge}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button 
            variant="primary" 
            size="lg"
            href="/case-studies"
          >
            View All Case Studies
          </Button>
        </div>
      </div>
    </section>
  );
}
